import axios from 'Utils/axios'
import { message } from 'antd'

export const sendProductToCustomer = (productId?: string, customerId?: string) => {
  message.loading('Sending...', 1)
  axios.post(`/store-farming/products/send-to-customer?ps_id=${customerId}&product_id=${productId}`)
}
